import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import { ContinentSearchParams, EaContinentsList } from '../models/custom-climate.model';

@Injectable({ providedIn: 'root' })
export class EaContinentService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ApiUrlInjectionToken) as string;

  search(params: ContinentSearchParams): Observable<EaContinentsList> {
    return this.http.get<EaContinentsList>(`${this.baseUrl}/ea-continents`, {
      params: this.cleanParams(params),
    });
  }

  private cleanParams(p: ContinentSearchParams): Record<string, string> {
    const out: Record<string, string> = {};
    out['page'] = String(p.page);
    out['pageSize'] = String(p.pageSize);
    if (p.text) out['text'] = p.text;
    if (p.orderByField) out['orderByField'] = p.orderByField;
    if (p.orderByDirection) out['orderByDirection'] = p.orderByDirection;
    return out;
  }
}
